// extracted by mini-css-extract-plugin
export default {"GitHubAvatar":"User-module__GitHubAvatar--bEXDV","Link":"User-module__Link--Fzkfz"};